import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayPositiveNumbers',
  pure: true,
  standalone: false,
})
export class DisplayPositiveNumbersPipe implements PipeTransform {
  constructor() {}

  public transform(content: string, numbers: number[]): string {
    return numbers.findIndex((num) => num <= 0) < 0 ? content : '';
  }
}
